import { hideScrollBar } from '@repo/ui/components/utilities';
import styled from 'styled-components';

import { CenterChildren } from 'styles/layouts';

import type {
  CarouselCellProps,
  ItemsWrapperProps,
  CarouselContainerProps,
} from './types';

const getItemsWrapperPadding = ({
  itemWidth,
  centered,
}: ItemsWrapperProps): string => {
  if (centered) {
    return `padding: 0 calc((100% - ${itemWidth}px) / 2); box-sizing: border-box`;
  }
  return '';
};

export const CarouselContainer = styled.div.attrs(() => ({
  draggable: false,
}))<CarouselContainerProps>`
  cursor: ${({ dragging }) => (dragging ? 'grabbing' : 'grab')};
  overflow: hidden;
  touch-action: none;
`;

export const ItemsWrapper = styled.div<ItemsWrapperProps>`
  display: flex;
  align-items: center;
  white-space: nowrap;
  user-select: none;
  overflow-x: auto;
  scroll-snap-type: ${({ snapScrollType }) =>
    snapScrollType ? `x ${snapScrollType}` : 'none'};

  gap: ${({ gap }) => `${gap}px`};

  ${hideScrollBar}

  ${getItemsWrapperPadding}
`;

export const CarouselCell = styled.div<CarouselCellProps>`
  min-width: ${({ itemWidth }) => `${itemWidth}px`};
  max-width: ${({ itemWidth }) => `${itemWidth}px`};
  pointer-events: none;
  scroll-snap-align: ${({ centered }) => (centered ? 'center' : 'none')};
  scroll-snap-stop: always;
`;

export const EmptyContainer = styled(CenterChildren)`
  height: auto;
`;
